import Vuex from 'vuex';

const state = {
  isMobileMenuOpened: false,
  currentNavigationItem: null
};

const getters = {
  isMobileMenuOpened: (state, getters, rootState) => {
    return state.isMobileMenuOpened;
  },
  hasCurrentNavigationItem: (state, getters, rootState) => {
    return state.currentNavigationItem != null;
  },
};

const actions = {
  toggleMobileMenu: ({ state, commit, dispatch }, { isOpened, clicked }) => {
    if(!isOpened && clicked) {
      dispatch('overlay/hide', {}, { root:true });
      if(state.currentNavigationItem) {
        const currentNavigationItem = null;
        dispatch('setCurrentNavigationItem', { currentNavigationItem });
      }
    }
    commit('changeOpenState', { isMobileMenuOpened: isOpened });
  },
  setCurrentNavigationItem: ({ state, commit, rootState, dispatch }, currentNavigationItem) => {

    if(state.currentNavigationItem && currentNavigationItem == null) {
      commit('setShowCurrentItemState', { open: false });
      commit('setCurrentNavigationItemState', { currentNavigationItem });

    }else if(state.currentNavigationItem && state.currentNavigationItem != currentNavigationItem) {
      commit('setShowCurrentItemState', { open: false });
      commit('setCurrentNavigationItemState', { currentNavigationItem });

      //If click on the same sub navigation then close it
    } else if (state.currentNavigationItem && state.currentNavigationItem == currentNavigationItem) {
      currentNavigationItem = null;
      commit('setCurrentNavigationItemState', { currentNavigationItem });

      //Set current navigation
    } else {
      commit('setCurrentNavigationItemState', { currentNavigationItem });

    }
  }
};

const mutations = {
  changeOpenState: (state, { isMobileMenuOpened }) => {
    state.isMobileMenuOpened = isMobileMenuOpened;
  },
  setShowCurrentItemState: (state, { open }) => {
    state.currentNavigationItem.isOpened = open;
  },
  setCurrentNavigationItemState: (state, { currentNavigationItem }) => {
    state.currentNavigationItem = currentNavigationItem;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./store/modules/mainnavigation.js